<template>
  <AdminLayout :title="$t('admin_sale_req.sale_req_title')" :current="$c.ADMIN.TAB.SALE">
    <div class="section">
      <div class="container" align=center>
        <div class="unit leftright">
          <div>
            <b-button class="but" style="margin-right: 0.5em;" v-for="(button, k,i) in buttons" :key="i" variant="white" :pressed="date === k" @click="change_range(k,i)" >{{button}}</b-button>
          </div>
          <b-button variant="none" class="apply_btn"  @click="refresh(true)">{{$t('admin_sale_req.search')}}</b-button>
        </div>
        <div v-for="(item, i) in items" :key="i" style="margin-top: 14px;">
          <b-row class = "row">
            <b-col cols="6">
              <div class="search_input"
                            style="text-align: center"
              >{{Utils.formatPhoneNumber(item.f_phone)}}</div>
            </b-col>
            <b-col cols="3">
              <b-button variant="none" :class="item.f_status=== $c.SITE_STATUS.DROP_OFF? 'primary' : 'inactive'" >{{$t('admin_sale_req.drop_off')}}</b-button>
            </b-col>
            <b-col cols="3">
              <b-button variant="none" :class="item.f_status=== $c.SITE_STATUS.PENDING? 'primary' : 'inactive'">{{$t('admin_sale_req.temporary_save')}}</b-button>
            </b-col>
          </b-row>
        </div>
      </div>
    </div>
  </AdminLayout>
</template>
<script>
import AdminLayout from './controls/adminlayout'
import moment from "moment";
import Utils from "../../../../config/utils";

export default {
  name: "AdminSaleReq",
  components: {
    AdminLayout
  },
  data() {
    return {
      buttons: {
        TODAY: this.$t('admin_sale_req.today'),
        YESTERDAY: this.$t('admin_sale_req.yesterday'),
        YYESTERDAY: this.$t('admin_sale_req.day_before_yesterday'),
      },
      date:'TODAY',
      search_date:moment().format('YYYY-MM-DD'),
      items:[
      ],
      Utils: Utils,
    }
  },
  methods:{
    change_range(key, date){
      this.date = key;
      this.search_date = moment().subtract(date, 'day').format('YYYY-MM-DD');
    },
    refresh(clear = false){
      Utils.requestGet(this.$c.API.Admin.getSaleReqUserList, {
        date: this.search_date
      }).then(result => {
        if (result.code === this.$c.API_RES_CODE.SUCCESS) {
          if(clear){
            this.items = result.data.list;
          }else{
            if(result.data.list.length > 0)
            this.items =[...this.items, ...result.data.list];
          }
        } else {
          Utils.toast(this, result.msg);
        }
      });
    },
  },
  mounted() {
    this.refresh(true);
  }
}
</script>

<style lang="scss" scoped>
@import '../../../../assets/css/main/admin/Admin.scss';
.but{
font-size: 0.8em;
  padding:0.5em 1em;
}

.col-3 {
  height: 100%;
  padding: 0 0.1em 0 0.1em;
}

.col-3>button{
  width:95%;
  height: 3em;
  border-width: 1px;
}

.col-6 {
  padding-left: 0;
}

.row {
  align-items: center;
  margin:0.5em 0 0.5em 0;
}
.apply_btn{
  height: 33px;
  width: 83px;
  background-color: #0840ba;
  border-radius: 3px;
  color: white;
  font-size: $fs_14;
  font-family: $korean_gd_15_r;
}
.search_input {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 45px;
  border: solid 1px #323232;
  border-radius: 1px;
  color: $black;
  font-size: $fs_18;
  font-family: $korean_gd_14_r;
}

.primary{
  background-color: #267fff;
  border-radius: 4px;
  justify-content: center;
  width: 86px;
  color: white;
  text-align: center;
  font-size: $fs_16;
  font-family: $korean_gd_15_r;
}
.inactive{
  @extend .primary;
  border: solid 1px #666666;
  color: #666666;
  background-color: white;
}
</style>



// WEBPACK FOOTER //
// src/components/contents/main/admin/AdminSaleReq.vue